<template lang="pug">
.container
  .error-body.m-auto.align-items-center.d-flex.flex-column.justify-content-center
    .image-animation.position-relative
      svg(id="text" width="94" height="37" viewBox="0 0 94 37" fill="none" xmlns="http://www.w3.org/2000/svg")
        path(d="M0.972656 29.3471H17.8393V35.7965H23.9506V29.3471H28.4737V24.1706H23.9506V1.03748H15.9748L0.972656 24.3403V29.3471ZM17.9083 24.1706H7.53285V23.899L17.6321 8.16579H17.9083V24.1706Z" fill="#3C67FF")
        path(d="M47.058 36.4584C55.5863 36.4754 60.679 29.8562 60.679 18.4509C60.679 7.11352 55.5517 0.562256 47.058 0.562256C38.5643 0.562256 33.4542 7.09654 33.437 18.4509C33.437 29.8393 38.5298 36.4584 47.058 36.4584ZM47.058 31.1461C42.6558 31.1461 39.8936 26.8012 39.9108 18.4509C39.9281 10.1685 42.673 5.80666 47.058 5.80666C51.4602 5.80666 54.2052 10.1685 54.2224 18.4509C54.2224 26.8012 51.4775 31.1461 47.058 31.1461Z" fill="#3C67FF")
        path(d="M65.7761 29.3471H82.6427V35.7965H88.7541V29.3471H93.2771V24.1706H88.7541V1.03748H80.7782L65.7761 24.3403V29.3471ZM82.7118 24.1706H72.3363V23.899L82.4356 8.16579H82.7118V24.1706Z" fill="#3C67FF")

      svg(id="anim" width="168" height="168" viewBox="0 0 168 168" fill="none" xmlns="http://www.w3.org/2000/svg")
        circle(opacity="0.5" cx="65.8952" cy="85.1254" r="44.2292" fill="#7190FF")
        path(opacity="0.5" d="M98.8244 98.8244C116.097 81.5518 116.097 53.5474 98.8244 36.2748C81.5518 19.0022 53.5474 19.0022 36.2748 36.2748C19.0022 53.5474 19.0022 81.5518 36.2748 98.8244C53.5474 116.097 81.5518 116.097 98.8244 98.8244ZM98.8244 98.8244L133.725 133.725" stroke="#0A3BE7" stroke-width="6")

    p.text-mono4.mb-5.error-text.text-center {{ $t("error.page404") }}
    .btn-group.error-btn
      button.btn.btn-default.btn-outline(@click="$chatbox.show")
        svg(class="mr-half" width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg")
          g
            circle(cx="4" cy="4.5" r="4" fill="#3C67FF")
        | {{ $t("generals.liveC" )}}
      router-link.btn.btn-default.btn-primary(:to="{ name: 'Dashboard' }") {{ $t("thanks.back") }}
</template>

<script>
export default {
  name: "Error404"
};
</script>

<style lang="scss" scoped>
.error-body {
  min-width: 368px;
  // min-height: 378px;
  max-width: 368px;
  // max-height: 378px;
  height: calc(100vh - 65px);

  .image-animation {
    min-width: 168px;
    min-height: 168px;

    #text {
      right: 15px;
      position: absolute;
      top: 30%;
    }

    #anim {
      position: absolute;
      right: -10px;
      bottom: 20px;

      animation-name: magnifying;
      animation-duration: 2s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;

      transition: all 0.3s ease;
    }
  }

  .error-text {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
  }

  .error-btn {
    .btn {
      min-width: 180px;
    }
  }
}

@keyframes magnifying {
  // Right
  6% {
    right: -20px;
    bottom: 10px;
  }

  12% {
    right: -45px;
    bottom: 0px;
  }

  18% {
    right: -60px;
    bottom: 10px;
  }

  24% {
    right: -80px;
    bottom: 20px;
  }

  30% {
    right: -60px;
    bottom: 30px;
  }

  36% {
    right: -40px;
    bottom: 40px;
  }

  42% {
    right: -20px;
    bottom: 30px;
  }

  48% {
    right: -10px;
    bottom: 20px;
  }

  // Left
  54% {
    right: 10px;
    bottom: 10px;
  }

  60% {
    right: 30px;
    bottom: 0;
  }

  66% {
    right: 50px;
    bottom: 10px;
  }

  72% {
    right: 70px;
    bottom: 20px;
  }

  78% {
    right: 50px;
    bottom: 30px;
  }

  84% {
    right: 30px;
    bottom: 40px;
  }

  90% {
    right: 10px;
    bottom: 30px;
  }

  100% {
    right: -10px;
    bottom: 20px;
  }
}
</style>
